<template>
  <nav-bar title="创建监管领导用户" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <organizational-menu :list="[organizationalList]" title="创建监管领导" @select="onSelect" />
  </Content>
  <!-- 添加人员 -->
  <add-personnel
    ref="addPersonnel"
    :leader="true"
    @submit-values="
      values =>
        handleAddPersonnelSubmit({
          ...values,
          roleId: '9',
          streetCode: streetCode,
          tenantId: tenantId
        })
    "
  />
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { getOrgList, addSuperviser } from '@/api/user'
import { delCompanyAdmin } from '@/api/chome'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useAddPersonnel } from '@/hooks/useAddPersonnel'
import { useDelPersonnel } from '@/hooks/useDelPersonnel'
export default {
  name: 'regulatoryLeaderUsers',
  provide: {
    hideOperation: false
  },
  setup() {
    const store = useStore()
    const myStreetCode = computed(() => store.state.roleInfo.companyId)
    const regionCode = localStorage.getItem('tenant_region')
    const tenantId = localStorage.getItem('tenant_id')
    // 获取组织架构数据
    const organizationalList = ref([])
    // const firstLoading = ref(true)
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      getOrgList,
      data => {
        organizationalList.value = data
      },
      {
        streetCode: myStreetCode.value || regionCode || '371500000000',
        roleId: '9'
      }
    )
    getDataLoading()
    // 操作
    const streetCode = ref('')
    const onSelect = value => {
      if (value.action.type === 'add') {
        streetCode.value = value.item.roleId
        handleAddPersonnelClick()
      } else if (value.action.type === 'del') {
        handleDelPersonnelClick(value.item.id)
      }
    }
    // 添加人员
    const {
      addPersonnel,
      handleAddPersonnelClick,
      handleAddPersonnelSubmit
    } = useAddPersonnel(addSuperviser, () => {
      // 添加成功后回调
      getDataLoading()
    })
    // 删除人员
    const { handleDelPersonnelClick } = useDelPersonnel(delCompanyAdmin, () => {
      // 删除成功后回调
      getDataLoading()
    })
    return {
      getDataLoading,
      showLoading,
      isLoading,
      organizationalList,
      onSelect,
      handleAddPersonnelSubmit,
      addPersonnel,
      streetCode,
      regionCode,
      tenantId
    }
  }
}
</script>

<style lang="scss" scoped></style>
